import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Outlet, useParams } from "react-router-dom"

import CourseReviewModal from "../components/core/ViewCourse/CourseReviewModal"
import VideoDetailsSidebar from "../components/core/ViewCourse/VideoDetailsSidebar"
import { fetchCourseDetails } from "../services/operations/courseDetailsAPI"
import {
  setCompletedLectures,
  setCourseSectionData,
  setEntireCourseData,
  setTotalNoOfLectures,
} from "../slices/viewCourseSlice"

import "./ViewCourse.css"

export default function ViewCourse() {
  const { courseId } = useParams()
  const { token } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const [reviewModal, setReviewModal] = useState(false)

  useEffect(() => {
  (async () => {
    const courseData = await fetchCourseDetails(courseId, token)
    
    if (
      courseData &&
      courseData.courseDetails &&
      Array.isArray(courseData.courseDetails.courseContent)
    ) {
      dispatch(setCourseSectionData(courseData.courseDetails.courseContent))
      dispatch(setEntireCourseData(courseData.courseDetails))
      // dispatch(setCompletedLectures(courseData.completedVideos))
      dispatch(setCompletedLectures({
        courseId: courseData.courseDetails._id,
        lectures: (courseData.completedVideos || []).map(id => String(id))
      }));


      let lectures = 0
      courseData.courseDetails.courseContent.forEach((sec) => {
        lectures += sec.subSection.length
      })
      dispatch(setTotalNoOfLectures(lectures))
    } else {
      console.error("Course data incomplete or malformed", courseData)
    }
  })()
}, [courseId, token, dispatch])


  return (
    <>
      <div className="view-course-wrapper">
        <VideoDetailsSidebar setReviewModal={setReviewModal} />
        <div className="view-course-main">
          <div className="view-course-content">
            <Outlet />
          </div>
        </div>
      </div>
      {reviewModal && <CourseReviewModal setReviewModal={setReviewModal} />}
    </>
  )
}
